import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faPatreon, faTwitch } from '@fortawesome/free-brands-svg-icons';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

import Section from '../components/Section';
import Loading from '../components/Loading';

import utils from '../util/utils';
import api from '../util/api';

const linkregex = /[?#&\s]/g;

export default class Rewards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blizzardShowLogin: false,
            patreonShowLogin: false,
            patreonShowRewards: false,
            twitchShowLogin: false,
            twitchShowRewards: false,
            tier: 0,
            inputTwitch: '',
            inputYouTube: '',
            inputTwitter: '',
            thanks: false,
            refresh: false,
            guild: '',
            saving: false,
            saved: false,
            account: null,
            character: null,
            guilds: null
        };
    }

    componentDidMount() {
        this.init();
    }

    init = async () => {
        const token = this.blizzardToken();

        if (token != null) {
            this.loadBlizzard(token);
            this.loadPatreon(token);
            this.loadTwitch(token);
        }
    }

    logout = () => {
        localStorage.removeItem('token.patreon');
        localStorage.removeItem('token.twitch');
        this.setState({ patreonShowLogin: true, patreonShowRewards: false, twitchShowLogin: true, twitchShowRewards: false, tier: 0 });
    }

    blizzardToken = () => {
        const storage = localStorage.getItem('token.blizzard');
        const token = storage ? JSON.parse(storage) : null;

        // validate user token
        if (!token?.region || !token?.expires_at) {
            // TODO need to show "please login" message
            this.setState({ blizzardShowLogin: true });
            return null;
        } else if (token.expires_at < Date.now()) {
            // expired token
            this.props.history.push('/redirect?to=blizzard&from=' + encodeURIComponent('/rewards') + '&region=' + encodeURIComponent(token.region));
            return null;
        }

        this.setState({ blizzardShowLogin: false });
        return token;
    }

    loadBlizzard = async (token) => {
        // Blizzard API call
        const response = await api.post('user/' + encodeURIComponent(token.region), token);
        if (response.status !== 200) return null;

        const json = await response.json();
        if (!json?.characters?.length) return null;

        // load stubs from the database
        const response2 = await api.post('stubs', json.characters);
        if (response2.status !== 200) return null;

        const json2 = await response2.json();

        // first setup main character
        // TODO use new ability to backup multiple accounts/characters
        this.setState({ character: json2?.[0]?.character?.key, account: json2?.[0]?.character?.account });

        // then gather a list of unique guilds
        const parseGuilds = () => {
            const guilds = {};
            for (let c of json2) {
                if (!c.character.guildName) continue;

                const key = c.character.region + '#' + c.character.guildRealm + '#' + c.character.guildName;
                const name = c.character.guildName + '-' + c.character.guildRealm;
                guilds[key] = { key, name };
            }
            return Object.values(guilds);
        }

        // sort the list of guilds
        const guilds = parseGuilds();
        guilds.sort((a, b) => utils.collator.compare(a.name, b.name));
        this.setState({ guilds });
    }

    loadPatreon = async (blizzard) => {
        const storage = localStorage.getItem('token.patreon');
        const token = storage ? JSON.parse(storage) : null;
        if (!token?.expires_at || (Date.now() > token.expires_at)) {
            localStorage.removeItem('token.patreon');
            this.setState({ patreonShowLogin: true });
            return;
        }

        const response = await api.post('rewards/patreon', { ...token, rewards: true, character: this.state.character });
        if (response.status !== 200) {
            localStorage.removeItem('token.patreon');
            this.setState({ patreonShowLogin: true });
            return;
        }

        const json2 = await response.json();
        this.setState({ patreonShowRewards: true, tier: json2.tier, thanks: json2.thanks, refresh: json2.refresh, inputTwitch: json2.twitch, inputYouTube: json2.youtube, inputTwitter: json2.twitter, guild: json2.guild });

        // new code, not ready yet
        api.post('connect', {
            blizzard: {
                region: blizzard.region,
                token: blizzard.access_token
            },
            patreon: {
                token: token.access_token
            }
        });
    }

    loadTwitch = async (blizzard) => {
        const storage = localStorage.getItem('token.twitch');
        const token = storage ? JSON.parse(storage) : null;
        if (!token?.expires_at || (Date.now() > token.expires_at)) {
            localStorage.removeItem('token.twitch');
            this.setState({ twitchShowLogin: true });
            return;
        }

        const response = await api.post('rewards/twitch', { ...token, rewards: true, character: this.state.character });
        if (response.status !== 200) {
            localStorage.removeItem('token.twitch');
            this.setState({ twitchShowLogin: true });
            return;
        }

        const json2 = await response.json();
        this.setState({ twitchShowRewards: true, tier: json2.tier, thanks: json2.thanks, refresh: json2.refresh, inputTwitch: json2.twitch, inputYouTube: json2.youtube, inputTwitter: json2.twitter, guild: json2.guild });

        // new code, not ready yet
        api.post('connect', {
            blizzard: {
                region: blizzard.region,
                token: blizzard.access_token
            },
            twitch: {
                token: token.access_token
            }
        });
    }

    patreonButton() {
        if (!this.state.patreonShowLogin) return null;

        return (
            <div className="mr-2">
                <Link to={'/redirect?to=patreon&from=' + encodeURIComponent('/rewards')} className="btn btn-patreon text-nowrap"><FontAwesomeIcon icon={faPatreon} className="mr-2" />Claim Patreon Rewards</Link>
            </div>
        );
    }

    twitchButton() {
        if (!this.state.twitchShowLogin) return null;

        return (
            <div className="mr-2">
                <Link to={'/redirect?to=twitch&from=' + encodeURIComponent('/rewards')} className="btn btn-twitch text-nowrap"><FontAwesomeIcon icon={faTwitch} className="mr-2" />Claim Twitch Rewards</Link>
            </div>
        );
    }

    rewardThanks = async (event, thanks) => {
        this.setState({ thanks });
    }

    rewardRefresh = async (event, refresh) => {
        this.setState({ refresh });
    }

    saveRewards = async () => {
        this.setState({ saving: true, saved: false });

        const payload = {
            rewards: true,
            thanks: this.state.thanks,
            refresh: this.state.refresh,

            guild: document.getElementById('rewardguild')?.value,

            twitch: this.state.inputTwitch,
            youtube: this.state.inputYouTube,
            twitter: this.state.inputTwitter
        };
        if (this.state.character) payload.character = this.state.character;

        for (let type of [ 'patreon', 'twitch' ]) {
            if (!localStorage.getItem('token.' + type)) continue;

            const token = JSON.parse(localStorage.getItem('token.' + type));
            const response = await api.post('rewards/' + type, { ...payload, ...token });
            if (response.status !== 200) {
                alert('An unknown error occurred. Please try again in a few minutes.');
                this.setState({ saving: false, saved: false });
                return;
            }
        }

        // new save
        {
            /*
            if (!this.state.account) {
                alert('An unknown error occurred. Please try again in a few minutes.');
                this.setState({ saving: false, saved: false });
                return;
            }
            */

            const payload = {
                account: this.state.account,
                thanks: this.state.thanks,
                refresh: this.state.refresh,
                guild: document.getElementById('rewardguild')?.value,

                links: {
                    twitch: this.state.inputTwitch,
                    youtube: this.state.inputYouTube,
                    twitter: this.state.inputTwitter
                }
            };

            const token = JSON.parse(localStorage.getItem('token.blizzard')); // assumes valid token
            api.post('rewards2?token=' + encodeURIComponent(token.region) + encodeURIComponent(token.access_token), payload);
            /*
            const response = await api.post('rewards2?token=' + encodeURIComponent(token.region) + encodeURIComponent(token.access_token), payload);
            if (response.status !== 200) {
                alert('An unknown error occurred. Please try again in a few minutes.');
                this.setState({ saving: false, saved: false });
                return;
            }
            */
        }

        this.setState({ saving: false, saved: true });
        this.logout();
    }

    handleTwitch = (event) => {
        this.setState({ inputTwitch: event.target.value.replace(linkregex, '') });
    }

    handleYouTube = (event) => {
        this.setState({ inputYouTube: event.target.value.replace(linkregex, '') });
    }

    handleTwitter = (event) => {
        this.setState({ inputTwitter: event.target.value.replace(linkregex, '') });
    }

    render() {
        return (
            <>
                {this.renderButtons()}
                {this.renderRewards()}
            </>
        );
    }

    renderButtons() {
        if (this.state.blizzardShowLogin) {
            return (
                <Section title="Supporter Rewards">
                    Please login using Battle.net in order to claim your rewards
                </Section>
            );
        }

        if (this.state.patreonShowLogin && this.state.twitchShowLogin) {
            return (
                <Section title="Supporter Rewards">
                    Thank you for choosing to support <i>Data for Azeroth</i>! Your contributions help cover hosting costs and keep the site running.
                    Please use the buttons below to claim your rewards.
                    <div className="d-flex flex-wrap justify-content-center mt-3">
                        {this.patreonButton()}
                        {this.twitchButton()}
                    </div>
                    {this.state.saved ?
                        <div className="d-flex flex-wrap justify-content-center mt-3">
                            <span className="p-2 bar rounded text-center">Rewards Saved!</span>
                        </div>
                    : null}
                </Section>
            );
        }

        if (!this.state.patreonShowRewards && !this.state.twitchShowRewards) {
            // still loading
            return <Loading message="Loading..." />;
        }

        return null;
    }

    patreonTag() {
        return <a href="https://www.patreon.com/shoogen" target="external" className="btn btn-patreon badge"><FontAwesomeIcon icon={faPatreon} className="mr-2" />Patreon</a>;
    }

    twitchTag() {
        return <a href="https://twitch.tv/shoogen" target="external" className="btn btn-twitch badge"><FontAwesomeIcon icon={faTwitch} className="mr-2" />Twitch</a>;
    }

    renderRewards() {
        let preview = false;
        if (this.state.blizzardShowLogin) {
            preview = true;
        } else if (this.state.patreonShowLogin && this.state.twitchShowLogin) {
            preview = true;
        } else if (!this.state.patreonShowRewards && !this.state.twitchShowRewards) {
            return null;
        }

        const rewards = [];

        // Tier 0
        if (preview) {
            rewards.push(
                <div key="header">
                    <p>
                        If you are enjoying the site, please consider becoming a supporter and get access to the following rewards!
                    </p>
                </div>
            );
        } else if (this.state.tier === 0) {
            if (this.state.patreonShowRewards) {
                rewards.push(
                    <div key="rewards0">
                        <h5>No Patreon Subscription Found</h5>
                        <p>Your Patreon account is not eligible for any rewards. It may take some time for Patreon to process your pledge. Please contact me if you need any help.</p>
                        <a href="https://www.patreon.com/shoogen" target="external" className="btn btn-patreon text-nowrap"><FontAwesomeIcon icon={faPatreon} className="mr-2" />Become a Patron</a>
                    </div>
                );
            } else {
                rewards.push(
                    <div key="rewards0">
                        <h5>No Twitch Subscription Found</h5>
                        <p>Your Twitch account is not eligible for any rewards. It may take some time for Twitch to process your subscription. Please contact me if you need any help.</p>
                        <a href="https://twitch.tv/shoogen" target="external" className="btn btn-twitch text-nowrap"><FontAwesomeIcon icon={faTwitch} className="mr-2" />Subscribe (Free w/ Prime)</a>
                    </div>
                );
            }
        }

        // Tier 1
        if (preview) {
            rewards.push(
                <div key="rewards1">
                    <h5>Thank You Tier {this.patreonTag()} {this.twitchTag()}</h5>
                    <ul>
                        <li>A <i>Thank You</i> ribbon will be shown on your character's profile page and leaderboard rankings. Your main character will also appear on the <i>Thank You</i> page.</li>
                        <li>Receive a special role in the <i>Data for Azeroth</i> Discord server with access to special channels.</li>
                        <li>Links to your Twitch and YouTube channels can be displayed on your character's profile page and leaderboard rankings.</li>
                    </ul>
                </div>
            );
        } else if (this.state.tier >= 1) {
            // Thank You
            rewards.push(
                <div key="rewards1">
                    <h5>Thank You</h5>
                    <p>A <i>Thank You</i> ribbon will be shown on your character's profile page and leaderboard rankings. Your main character will also appear on the <i>Thank You</i> page.</p>
                    <div className="text-center"><FormControlLabel control={<Switch checked={this.state.thanks} onChange={this.rewardThanks} />} label={this.state.thanks ? 'Enabled' : 'Disabled'} /></div>
                </div>
            );

            // Discord
            if (this.state.patreonShowRewards) {
                rewards.push(<div key="discord"><h5>Discord</h5><p>Please set up this reward by logging in to Patreon, and connect your Discord account within the settings.</p></div>);
            } else {
                rewards.push(<div key="discord"><h5>Discord</h5><p>Please set up this reward by logging in to Discord, and connect your Twitch account within the settings.</p></div>);
            }

            // Streamer Links
            rewards.push(
                <div key="links">
                    <h5>Streamer Links</h5>
                    <p>The following links will be shown on your character's profile page and leaderboard rankings. You may leave any link blank if you do not want it shown.</p>
                    <div className="col-lg-6 col-md-8 mx-auto">
                        <div className="input-group mb-1">
                            <div className="input-group-prepend">
                                <span className="input-group-text">https://twitch.tv/</span>
                            </div>
                            <input type="text" className="form-control" value={this.state.inputTwitch || ''} onChange={this.handleTwitch} />
                        </div>
                        <div className="input-group mb-1">
                            <div className="input-group-prepend">
                                <span className="input-group-text">https://youtube.com/</span>
                            </div>
                            <input type="text" className="form-control" value={this.state.inputYouTube || ''} onChange={this.handleYouTube} />
                        </div>
                        <div className="input-group mb-1">
                            <div className="input-group-prepend">
                                <span className="input-group-text">https://twitter.com/</span>
                            </div>
                            <input type="text" className="form-control" value={this.state.inputTwitter || ''} onChange={this.handleTwitter} />
                        </div>
                    </div>
                </div>
            );
        }

        // Tier 2
        if (preview) {
            rewards.push(
                <div key="rewards2">
                    <h5>Character Refresh Tier {this.patreonTag()} {this.twitchTag()}</h5>
                    <ul>
                        <li>All previous rewards, plus:</li>
                        <li>Your characters will be added to a priority queue that keeps them automatically updated.</li>
                    </ul>
                </div>
            );
        } else if (this.state.tier >= 2) {
            rewards.push(
                <div key="rewards2">
                    <h5>Character Refreshes</h5>
                    <p>Your characters will be automatically refreshed.</p>
                    <div className="text-center"><FormControlLabel control={<Switch checked={this.state.refresh} onChange={this.rewardRefresh} />} label={this.state.refresh ? 'Enabled' : 'Disabled'} /></div>
                </div>
            );
        }

        // Tier 5
        if (preview) {
            rewards.push(
                <div key="rewards5">
                    <h5>Guild Refresh Tier {this.patreonTag()}</h5>
                    <ul>
                        <li>All previous rewards, plus:</li>
                        <li>Your guild will be added to a priority queue that keeps all members automatically updated.</li>
                    </ul>
                </div>
            );
        } else if (this.state.tier >= 5) {
            rewards.push(
                <div key="rewards5">
                    <h5>Guild Refreshes</h5>
                    <p>Please select which guild you would like to have automatically refreshed.</p>
                </div>
            );
        }

        // Footer
        if (preview) {
            rewards.push(
                <div key="footer" className="d-flex flex-wrap justify-content-center mt-3">
                    <a href="https://www.patreon.com/shoogen" target="external" className="btn btn-patreon text-nowrap mr-2"><FontAwesomeIcon icon={faPatreon} className="mr-2" />Become a Patron</a>
                    <a href="https://twitch.tv/shoogen" target="external" className="btn btn-twitch text-nowrap"><FontAwesomeIcon icon={faTwitch} className="mr-2" />Subscribe (Free w/ Prime)</a>
                </div>
            );
        } else if (this.state.saving) {
            rewards.push(
                <div key="save" className="text-center mt-3">
                    <button className="btn btn-primary" disabled><FontAwesomeIcon icon={faCog} spin /> Saving...</button>
                    <button className="btn btn-primary ml-1" disabled>Cancel</button>
                </div>
            );
        } else {
            rewards.push(
                <div key="save" className="text-center mt-3">
                    {this.state.tier >= 1 ? <button className="btn btn-primary" onClick={this.saveRewards}>Save</button> : null}
                    <button className="btn btn-primary ml-1" onClick={this.logout}>Cancel</button>
                </div>
            );
        }

        const title = preview ? 'Not Yet a Supporter?' : (this.state.patreonShowRewards ? 'Patreon Rewards' : 'Twitch Rewards');
        return (
            <Section title={title}>
                {rewards}
            </Section>
        );
    }
}